import { Box, Select } from '@mantine/core'
import { omitKeys } from '@ospace/common/utils/object'
import { ProgramLayout } from '@ospace/layout'
import { VendorSalesPersonFilter } from '@ospace/shared'
import { CSVExportButton } from '@ospace/shared/components/CSVExportButton'
import { ALL } from '@ospace/shared/components/VendorSalesPersonFilter'
import React from 'react'

import { Notes } from './Notes'

const getPlainText = (html: string) => {
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  return tempDiv.textContent || tempDiv.innerText || ''
}

export const FilteredNotes = ({
  isFetching,
  data,
  label,
}: {
  isFetching: boolean
  label: string
  data: {
    notes: any[]
    vendorSalesPerson: {
      enabled: boolean
      data: any
    }
  }
}) => {
  const { SelectFilter, filteredData } = VendorSalesPersonFilter({
    data: data?.notes || [],
    vendorSalesPerson: data?.vendorSalesPerson?.data || [],
    filterKeyPath: 'company.id',
  })
  const [statusFilter, setStatusFilter] = React.useState<string>(ALL)
  const status = Object.keys(
    data?.notes.reduce((acc, note) => {
      return {
        ...acc,
        [note.deal.status]: 1,
      }
    }, {}) || {}
  ).sort((a, b) => a.localeCompare(b))

  return (
    <ProgramLayout status={isFetching ? 'loading' : 'ready'} pageId='programs' fluid={false}>
      {data && (
        <Box mt='xl'>
          <div className={`card`}>
            <div className='card-header border-0'>
              <h3
                className='card-title align-items-start flex-column'
                style={{
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    width: '100%',
                    paddingTop: '20px',
                  }}
                >
                  <span className='card-label fw-bolder fs-3'>{label}</span>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      flexDirection: 'row',
                      width: '50%',
                    }}
                  >
                    <Select
                      data={[
                        {
                          label: ALL,
                          value: ALL,
                        },
                      ].concat(status.map((s) => ({ label: s, value: s })))}
                      value={statusFilter}
                      onChange={(value) => {
                        setStatusFilter(value ?? ALL)
                      }}
                      label={`Status`}
                    />
                    <div
                      style={{
                        paddingLeft: '20px',
                      }}
                    >
                      {data?.vendorSalesPerson.enabled && { ...SelectFilter }}
                    </div>
                    <div
                      style={{
                        paddingLeft: '20px',
                        paddingTop: 26,
                      }}
                    >
                      <CSVExportButton
                        data={filteredData.map((note) =>
                          omitKeys(
                            {
                              ...note,
                              companyId: note.company.id,
                              companyName: note.company.name,
                              dealId: note.deal.id,
                              dealStatus: note.deal.status,
                              note: getPlainText(note.body),
                              personId: note.person.id,
                              personFirstName: note.person.firstName,
                              personLastName: note.person.lastName,
                              personJobTitle: note.person.jobTitle,
                              personEmail: note.person.email || '',
                              personPhone: note.person.phone || '',
                              preferredPartners: note.deal.properties?.preferred_partner || '',
                              preferredDistributors:
                                note.deal.properties?.preferred_distributors__ldr_tsa_2 || '',
                            },
                            ['body', 'deal', 'company', 'person', 'deletedAt']
                          )
                        )}
                        fileName={'account-insights'}
                      />
                    </div>
                  </div>
                </div>
              </h3>
            </div>
            <div className={`card-body`} style={{ overflow: 'scroll' }}>
              <Notes
                notes={filteredData?.filter((d) =>
                  statusFilter === ALL ? true : d.deal.status === statusFilter
                )}
              />
            </div>
          </div>
        </Box>
      )}
    </ProgramLayout>
  )
}
